<script setup lang="ts">
import { useI18n } from 'vue-i18n'
export interface FyzickaOsobaProps {}

const props = defineProps<FyzickaOsobaProps>()
const { t } = useI18n()
</script>

<template>
  <IDSKRow>
    <IDSKCol variant-desktop="two-thirds">
      <IDSKDetails open :title="t('zoppm.step0.zoppmUxZiadostPostup.title')">
        <IDSKHeading as="h3" variant="s" class="mb-0">{{
          t('zoppm.step0.zoppmUxZiadostPostup.registraciaTitle')
        }}</IDSKHeading>
        <IDSKParagraph>
          {{ t('zoppm.step0.zoppmUxZiadostPostup.registraciaDescription') }}
        </IDSKParagraph>
        <IDSKHeading as="h3" variant="s" class="mb-0">{{
          t('zoppm.step0.zoppmUxZiadostPostup.obsahTitle')
        }}</IDSKHeading>
        <IDSKParagraph>{{
          t('zoppm.step0.zoppmUxZiadostPostup.obsahDescription')
        }}</IDSKParagraph>
        <IDSKHeading as="h3" variant="s" class="mb-0">{{
          t('zoppm.step0.zoppmUxZiadostPostup.odoslanieTitle')
        }}</IDSKHeading>
        <IDSKParagraph>{{
          t('zoppm.step0.zoppmUxZiadostPostup.odoslanieDescription')
        }}</IDSKParagraph>
      </IDSKDetails>
    </IDSKCol>
  </IDSKRow>
</template>

<style lang="scss"></style>
